import { Box, IconButton } from "@mui/material";
import React from "react";
import { ReactNode } from "react-markdown";

type ImageSettingButtonProps = {
  onClick?: () => void;
  name?: string;
  "aria-label"?: string;
  icon?: ReactNode;
};

export function ImageSettingButton({ name, onClick, "aria-label": ariaLabel, icon }: ImageSettingButtonProps) {
  return (
    <Box
      sx={{
        width: "22px",
        height: "20px",
        padding: 0,
        borderRadius: "0px",
      }}
    >
      <IconButton
        sx={{
          width: "22px",
          height: "20px",
          padding: 0,
          boxShadow: "0px 0px 3.2px 0px #00000040",
          borderRadius: "4px",
        }}
        name={name}
        aria-label={ariaLabel}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    </Box>
  );
}
